import { call, takeEvery, put } from 'redux-saga/effects';

import { SET_LOCALE, INITIALIZE_LOCALE } from '../intl/intlModule';
import { updateUploadcareLocaleComplete } from './uyoModule';

export const importUploadcare = async () => import('uploadcare-widget');


const getLanguage = locale => locale.split('-')[0];


export function initUploadcareLocale({ locale }) {
    window.UPLOADCARE_LOCALE = getLanguage(locale);
}


export function* updateUploadcareLocale({ locale }) {
    const uploadcare = (yield call(importUploadcare)).default;
    uploadcare.plugin((uploadcareWidget) => {
        uploadcareWidget.locale.rebuild({ locale: getLanguage(locale) });
    });
    yield put(updateUploadcareLocaleComplete());
}


export function* updateUYOForLanguageWatcher() {
    yield takeEvery(INITIALIZE_LOCALE, initUploadcareLocale);
    yield takeEvery(SET_LOCALE, updateUploadcareLocale);
}
